module.exports = __webpack_public_path__ + "img/skinbox-small.f03cad8c.png";